module.exports = __webpack_public_path__ + "static/media/ST4-BG2.ee8e6f21.jpg";